import { render, staticRenderFns } from "./EmployeeDetails.vue?vue&type=template&id=54073f2a&scoped=true&"
import script from "./EmployeeDetails.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDetails.vue?vue&type=style&index=0&id=54073f2a&scoped=true&lang=css&"
import style1 from "./workforce-viewport-modal.css?vue&type=style&index=1&lang=css&"
import style2 from "./reserve-return-action.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54073f2a",
  null
  
)

export default component.exports